'use strict';

require('./PlatformLaunch.less');
